module.exports = __webpack_public_path__ + "static/img/aizs.5ecddd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aizs.png
// module id = G229
// module chunks = 0